var _defs, _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #00cc87;\n      }\n\n      .st1 {\n        fill: #3852a5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.32,38.34v-6.2c0-4.11,3.35-7.45,7.47-7.45h6.24c1.82,0,3.56.67,4.92,1.87-2.05,2.19-3.32,5.12-3.32,8.35v4.67h-14.06c-.68,0-1.26-.57-1.26-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.36,39.58h14.06c.68,0,1.26-.57,1.26-1.24v-6.2c0-4.11-3.35-7.45-7.47-7.45h-6.24c-1.82,0-3.57.68-4.93,1.87,2.05,2.19,3.32,5.12,3.32,8.35v4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.64,40.56s0,.01,0,.02,0,.01,0,.02v3.27c0,.69.54,1.24,1.24,1.24h26.25c.68,0,1.24-.56,1.24-1.24v-3.28s0,0,0-.01,0,0,0-.01v-5.65c0-5.64-4.59-10.23-10.22-10.23h-8.31c-2.61,0-4.98,1-6.79,2.61,0,0,0,0,0,0,0,0,0,0,0,0-2.08,1.87-3.4,4.58-3.4,7.6v5.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,18.21c4.19,0,7.59-3.42,7.59-7.62s-3.4-7.59-7.59-7.59-7.59,3.4-7.59,7.59,3.4,7.62,7.59,7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.09,19.31c3.07,0,5.58-2.49,5.58-5.55s-2.5-5.58-5.58-5.58-5.58,2.5-5.58,5.58,2.5,5.55,5.58,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.91,19.31c3.08,0,5.58-2.49,5.58-5.55s-2.5-5.58-5.58-5.58-5.58,2.5-5.58,5.58,2.5,5.55,5.58,5.55Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.75,53.4h7.27v27.79h-7.27v-27.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.95,53.4v30.46h7.3v-30.46h-7.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.08,63.58h-4.55l-4.62,4.09c-2.74,2.44-6.64,2.62-9.27.45l-2.12-1.76c-.21-.18-.34-.43-.36-.71-.02-.28.08-.55.27-.75l8.33-8.86h-21.75v21.61h5.44s.08,0,.11,0c.14.01.27.06.39.12.12.07.23.16.32.28.02.03.04.06.06.09l8.1,13.48c.81,1.34,2.6,1.77,4,.96,1.4-.78,1.91-2.48,1.21-3.9l-3.78-5.92c-.3-.47-.16-1.08.3-1.38.47-.3,1.08-.16,1.38.3l3.81,5.96s.02.02.03.04c0,.01,0,.02.01.03l1.02,1.6c.87,1.36,2.63,1.79,4.01.98,1.42-.81,1.93-2.56,1.18-3.97,0-.01,0-.03-.01-.04l-4.45-6.94c-.3-.46-.16-1.08.3-1.38.46-.3,1.08-.16,1.38.3l5.92,9.24c.84,1.35,2.64,1.79,4.01.98,1.39-.79,1.9-2.57,1.15-3.96,0-.01,0-.02-.01-.03l-6.36-9.93c-.3-.46-.16-1.08.3-1.38.47-.3,1.08-.16,1.38.3l7.71,12.05c.84,1.35,2.64,1.78,4.01.98,1.42-.82,1.93-2.56,1.18-3.97l-10.07-18.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.76,54.03c-1.56,0-2.89.57-3.95,1.69l-9.19,9.77,1.3,1.08c1.86,1.54,4.66,1.37,6.67-.4l4.9-4.34c.18-.16.42-.25.66-.25h9.13c.55,0,1,.45,1,1s-.45,1-1,1h-1.94l9.57,18.01c.39.73.55,1.5.56,2.27h7.48v-26.49l-14.31-3.34h-10.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalture);
export default __webpack_public_path__ + "static/media/calture.cf918cdf778800b9b12f17c098447bd7.svg";
export { ForwardRef as ReactComponent };